<div *ngFor="let toast of toasts; let i = index">
  <div *ngIf="toast.isBulkStatementSent" class="qbo-taost  toast-{{ toast.type }}" [style.bottom.px]="i * 100">
    <div class="toast-header">
      <div *ngIf="!toast?.isComplete" class="title-qbo-taost">
        <span class="icon-qb"> </span>
        <i class="fal fa-spinner font-primary rotate ml-2"></i>
        Sending statements
      </div>
      <div *ngIf="toast?.isComplete" class="title-qbo-taost">
        <span class="icon-qb"> </span>
        <i class="fal fa-check font-primary ml-2"></i>
        Statements sent
      </div>
    </div>
    <div class="toast-body font-600">
      <div class="row">
        <div class="col-8">Total Statements:</div>
        <div class="col">
          <span class="float-right">{{ toast.totalCount }}</span>
        </div>
      </div>
      <div class="row">
        <div class="col">Sent:</div>
        <div class="col">
          <span class="float-right">{{ toast.successCount }}</span>
        </div>
      </div>
      <div class="row">
        <div class="col">Failed:</div>
        <div class="col">
          <span class="float-right">{{ toast.failedCount }}</span>
        </div>
      </div>
      <div class="row">
        <div class="col">Pending:</div>
        <div class="col">
          <span class="float-right">{{ toast.pendingCount }}</span>
        </div>
      </div>
      <div *ngIf="toast?.isComplete" class="row"><div (click)="dismiss()" class="col pointer font-primary font-600">View statements</div></div>

      <!-- <span><strong>Sent:</strong> {{toast.successCount}}</span>
      <span><strong>Failed:</strong> {{toast.failedCount}}</span>
      <span><strong>Pending:</strong> {{toast.pendingCount}}</span> -->
    </div>
  </div>

  <div *ngIf="!toast.isBulkStatementSent" class="qbo-taost  toast-{{ toast.type }}" [style.bottom.px]="i * 100">
    <div class="toast-header">
      <div *ngIf="!toast.isBulkStatementSent" class="title-qbo-taost">
        <span class="icon-qb"> </span>
        QBO sync status
      </div>
    </div>
    <div class="toast-body">
      <p *ngIf="toast.statementName">Syncing: {{ toast.statementName }}</p>
      <span><strong>Total Invoices:</strong> {{ toast.totalInvoice }}</span>
      <span><strong>Synced:</strong> {{ toast.successCount }}</span>
      <span><strong>Failed:</strong> {{ toast.failedCount }}</span>
      <span><strong>Pending:</strong> {{ toast.pendingCount }}</span>
    </div>
  </div>
</div>
